import { useMemo, useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { setMathJaxAction } from "../../../redux/mathjax";

const Provider = ( props ) => {

  const dispatch = useDispatch();
  const setMathJax = useCallback( payload => { dispatch( setMathJaxAction( payload ) ) }, [ dispatch ] );

  useEffect( () => {
    if ( ! document.querySelector( '#MathJax-script' ) ) {
      window.MathJax = options;
      appendScript();
    }
  }, [] );

  const options = useMemo( () => {
    return {
      loader : {
        load : [ '[img]/img.min.js' ],
        paths : { img : 'https://fastly.jsdelivr.net/npm/mathjax-img@3' }
      },
      tex : {
        packages : { '[+]' : [ 'img' ] }
      },
      includeHtmlTags: {         //  HTML tags that can appear within math
        br: '\n'
      },
      startup : {
        ready : () => {
          setMathJax( { target : window.MathJax } );
          window.MathJax.startup.defaultReady();
        }
      },
      ...props.options
    };
  }, [ props.options ] );

  const appendScript = useCallback( () => {
    const script = document.createElement( 'script' );
    script.type = 'text/javascript';
    script.id = 'MathJax-script';
    script.async = true;
    script.src = props.url;
    document.querySelector( 'head' ).appendChild( script );
  }, [ props.url ] );

  return props.children || null;

};

Provider.defaultProps = {
  //url : 'https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-chtml-full.js'
  url : 'https://fastly.jsdelivr.net/npm/mathjax@3/es5/tex-chtml-full.js'
};

export default Provider;
